export default {
  path: '/trackers/tracker-types',
  name: 'TrackerTypes',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerTypesView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
